import { render, staticRenderFns } from "./EventsResults.vue?vue&type=template&id=245e6a94&scoped=true&"
import script from "./EventsResults.vue?vue&type=script&lang=js&"
export * from "./EventsResults.vue?vue&type=script&lang=js&"
import style0 from "./EventsResults.vue?vue&type=style&index=0&id=245e6a94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245e6a94",
  null
  
)

export default component.exports